module.exports = __webpack_public_path__ + "img/seguros_la_independencia.89513127.png";